import { BitmapTextStyle, BitmapTextStyleOpts } from './BitmapTextStyle';
import { BitmapText, Point, BitmapFont } from 'pixi.js';
import { Disposable } from '../utils';

export class StyledBitmapText extends BitmapText
{
    private listener?: Disposable;
    // override parent definition to specify just a point
    public anchor: Point;

    constructor(text:string, style: BitmapTextStyle|BitmapTextStyleOpts)
    {
        // have to make a normal object copy of the style because BitmapText can't handle
        // class setters/getters apparently

        let copy = style;
        if (style instanceof BitmapTextStyle)
        {
            copy = {
                fontName: style.fontName,
                fontSize: style.fontSize,
                tint: style.tint,
                align: style.align,
                letterSpacing: style.letterSpacing,
                maxWidth: style.maxWidth,
            };
        }
        super(text, copy);

        if (style instanceof BitmapTextStyle)
        {
            this.listener = style.subscribe((style) => {
                this.fontName = style.fontName;
                this.fontSize = style.fontSize;
                this.tint = style.tint;
                this.align = style.align;
                this.maxWidth = style.maxWidth;
                this.letterSpacing = style.letterSpacing;
            });
        }
        else
        {
            this.listener = null;
        }
    }

    public destroy()
    {
        this.listener?.dispose();
        super.destroy();
    }
}